import type { Role } from '@/types';

/** Reports is deliberately stricter than its Finances neighbours: Payments and Requests both admit
 *  `operational_associate`, but 112312 names Operational Associate as excluded. Single source of
 *  truth for the route guard; `nav.tsx` mirrors it as a literal because `config` may not import a
 *  feature (eslint-plugin-boundaries), and `nav.test.tsx` asserts the two agree. */
export const REPORTS_ROLES: Role[] = ['super_admin', 'admin'];

/** Human page name surfaced in the access-denied toast (ADR-0014). */
export const REPORTS_PAGE_NAME = 'Reports';

/** Verbatim AC copy (112312) for every Reports From/To pair — seven numeric ranges across the four
 *  tabs. Passed to `enforceRangePairs`; seven hand-written copies of one string is exactly where
 *  copies drift. */
export const REPORT_RANGE_ERROR = 'From value cannot be greater than To value.';

/** `<DataTable>` id for the Products tab — the root of its list query key and the namespace its
 *  page/pageSize/sort take in the URL. Each Reports tab is its own route, so a tab switch unmounts
 *  the page and drops the query string, which is what satisfies 112312's "the new tab's search
 *  field is empty" with no bespoke clearing logic. */
export const REPORTS_PRODUCTS_TABLE_ID = 'report-products';

/** `<DataTable>` id for the Device Activity tab — the root of its list query key, and what ticket
 *  07's filter drawer resets to page 1. One per tab; the four are independent. */
export const DEVICE_ACTIVITY_TABLE_ID = 'reports-device-activity';
